import { FaSort, FaDownload } from 'react-icons/fa';
import React, { useEffect, useState } from 'react';
import { handleError } from '../utils/errorHandler';
import { colorsRangeHex, formatNumber } from '../Transversal';
import { DEFAULT_FILTER, ArcFiltros } from '../Detalles/SesionDetalles';
import { API_URL, HEIGHT_BODY, WIDTH_RIGHT_PANEL, COLOR_FONT_TITLE } from '../Config';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import { useAppState } from './GraficoContext';
import { apiFetch } from '../apiClient';

let filterregrescarFiltros = 0;

interface SumaPoblacionVulnerable {
    totalPoblacion?: number;
    personasconDiscapacidad?: number;
    victimas?: number;
    personaEnProcesoDeReincorporacion?: number;
    personasDefensorasLideresSociales?: number;
    personasCampesinas?: number;
    orientacionesSexualesEIdentidadesDeGeneroDiversas?: number;
}

interface BarraProps {
    filtrar: string;
    codigoDivipola: string;
    indicador: any
}

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const Vulnerables: React.FC<BarraProps> = ({ filtrar, codigoDivipola, indicador }) => {
    const { tieneVulnerables, setTieneVulnerables } = useAppState();
    const [sumaPoblacionVulnerable, setdivipolaCantidad] = useState<SumaPoblacionVulnerable>();
    const [cantidadNacional, setCantidadNacional] = useState<number>(0);
    let cargado = false;

    const fetchDatos = async () => {
        try {
            const startTime = performance.now();
            const queryString = Object.keys(DEFAULT_FILTER)
                .filter(key => DEFAULT_FILTER[key as keyof ArcFiltros] !== undefined)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(DEFAULT_FILTER[key as keyof ArcFiltros] ?? '')}`)
                .join('&');
            const url = `${API_URL}/ArcIndicador/GetSumaPoblacionVulnerable?${queryString}`
            const response = await apiFetch(url);
            const data = await response.json();
            const cantidadNacionalNuevo = 0;
            cargado = true;
            setCantidadNacional(cantidadNacionalNuevo);
            setdivipolaCantidad(data);
            const endTime = performance.now();
            const duration = endTime - startTime;
            console.log(`Barras Fetch duration: ${duration} ms`);
        } catch (error) {
            handleError(error);
        }
    };

    const getDatos = async () => {
        console.log(DEFAULT_FILTER);
        if (DEFAULT_FILTER.regrescarFiltros != filterregrescarFiltros) {
            filterregrescarFiltros = DEFAULT_FILTER.regrescarFiltros;
            if (indicador != "") {
                fetchDatos();
            }
        }
    }

    useEffect(() => {
        getDatos();
    }, [filtrar, codigoDivipola, indicador]);

    const allNull = [
        sumaPoblacionVulnerable?.personasconDiscapacidad,
        sumaPoblacionVulnerable?.victimas,
        sumaPoblacionVulnerable?.personaEnProcesoDeReincorporacion,
        sumaPoblacionVulnerable?.personasDefensorasLideresSociales,
        sumaPoblacionVulnerable?.personasCampesinas,
        sumaPoblacionVulnerable?.orientacionesSexualesEIdentidadesDeGeneroDiversas
    ].every(v => v == null);

    const total = allNull ? null : sumaPoblacionVulnerable?.totalPoblacion || 0;
    const personasConDiscapacidadPorcentaje = ((sumaPoblacionVulnerable?.personasconDiscapacidad || 0) / (total || 1)) * 100;
    const victimasPorcentaje = ((sumaPoblacionVulnerable?.victimas || 0) / (total || 1)) * 100;
    const personaEnProcesoDeReincorporacionPorcentaje = ((sumaPoblacionVulnerable?.personaEnProcesoDeReincorporacion || 0) / (total || 1)) * 100;
    const personasDefensorasLideresSocialesPorcentaje = ((sumaPoblacionVulnerable?.personasDefensorasLideresSociales || 0) / (total || 1)) * 100;
    const personasCampesinasPorcentaje = ((sumaPoblacionVulnerable?.personasCampesinas || 0) / (total || 1)) * 100;
    const orientacionesSexualesEIdentidadesDeGeneroDiversasPorcentaje = ((sumaPoblacionVulnerable?.orientacionesSexualesEIdentidadesDeGeneroDiversas || 0) / (total || 1)) * 100;
    const totalVulnerables = allNull
        ? null
        : (sumaPoblacionVulnerable?.personasconDiscapacidad || 0)
            + (sumaPoblacionVulnerable?.victimas || 0)
            + (sumaPoblacionVulnerable?.personaEnProcesoDeReincorporacion || 0)
            + (sumaPoblacionVulnerable?.personasDefensorasLideresSociales || 0)
            + (sumaPoblacionVulnerable?.personasCampesinas || 0)
            + (sumaPoblacionVulnerable?.orientacionesSexualesEIdentidadesDeGeneroDiversas || 0);

    var strPersonasconDiscapacidad = '-';
    var strVictimas = '-';
    var strPersonaEnProcesoDeReincorporacion  = '-';
    var strPersonasDefensorasLideresSociales  = '-';
    var strPersonasCampesinas  = '-';
    var strOrientacionesSexualesEIdentidadesDeGeneroDiversas  = '-';
    var strTotal =  '-';
    var strTotalVulnerables = '-';

    if (sumaPoblacionVulnerable) {
        
        if (sumaPoblacionVulnerable?.personasconDiscapacidad !== undefined && sumaPoblacionVulnerable.personasconDiscapacidad != null && !isNaN(sumaPoblacionVulnerable.personasconDiscapacidad)) {
            strPersonasconDiscapacidad = formatNumber(sumaPoblacionVulnerable.personasconDiscapacidad);
        }
        if (sumaPoblacionVulnerable?.victimas !== undefined && sumaPoblacionVulnerable.victimas != null && !isNaN(sumaPoblacionVulnerable.victimas)) {
            strVictimas = formatNumber(sumaPoblacionVulnerable.victimas);
        }
        if (sumaPoblacionVulnerable?.personaEnProcesoDeReincorporacion !== undefined && sumaPoblacionVulnerable.personaEnProcesoDeReincorporacion != null && !isNaN(sumaPoblacionVulnerable.personaEnProcesoDeReincorporacion)) {
            strPersonaEnProcesoDeReincorporacion = formatNumber(sumaPoblacionVulnerable.personaEnProcesoDeReincorporacion);
        }
        if (sumaPoblacionVulnerable?.personasDefensorasLideresSociales !== undefined && sumaPoblacionVulnerable.personasDefensorasLideresSociales != null && !isNaN(sumaPoblacionVulnerable.personasDefensorasLideresSociales)) {
            strPersonasDefensorasLideresSociales = formatNumber(sumaPoblacionVulnerable.personasDefensorasLideresSociales);
        }
        if (sumaPoblacionVulnerable?.personasCampesinas !== undefined && sumaPoblacionVulnerable.personasCampesinas != null && !isNaN(sumaPoblacionVulnerable.personasCampesinas)) {
            strPersonasCampesinas = formatNumber(sumaPoblacionVulnerable.personasCampesinas);
        }
        if (sumaPoblacionVulnerable?.orientacionesSexualesEIdentidadesDeGeneroDiversas !== undefined && sumaPoblacionVulnerable.orientacionesSexualesEIdentidadesDeGeneroDiversas != null && !isNaN(sumaPoblacionVulnerable.orientacionesSexualesEIdentidadesDeGeneroDiversas)) {
            strOrientacionesSexualesEIdentidadesDeGeneroDiversas = formatNumber(sumaPoblacionVulnerable.orientacionesSexualesEIdentidadesDeGeneroDiversas);
        }
        if (totalVulnerables !== undefined && totalVulnerables != null && !isNaN(totalVulnerables)) {
            strTotalVulnerables = formatNumber(totalVulnerables);
        }
        if (total !== undefined && total != null && !isNaN(total)) {
            strTotal = formatNumber(total);
        }
         
    }

    useEffect(() => {
        if (isNaN(totalVulnerables ?? NaN)) {        
            setTieneVulnerables(false);        
        } else {
            setTieneVulnerables(true);
        }
    }, [totalVulnerables, setTieneVulnerables]);

    if (isNaN(totalVulnerables ?? NaN)) {        
        return <div></div>;
    }

    return (
        <div style={{ alignItems: 'center', backgroundColor: '#fff', borderTop: '1px solid #ccc', float: 'left', margin: '10px 10px 0px 10px', padding: '10px 0px 0px 10px', width: '350px', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', height: '220px' }}>
            <table style={{ width: '100%', maxHeight: 220 }}>
                <tbody>
                    <tr style={{ height: 18, textAlign: 'center', verticalAlign: 'top' }}>
                        <td colSpan={2} style={{ textAlign: 'center' }}>
                            <h3 style={{ color: "#2c66a4", fontWeight: 'bold' }}>Otras desagregaciones</h3>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: '100%', textAlign: 'center', }}>
                            <table style={{ width: '100%', }} cellPadding={0} cellSpacing={0}>
                                <tbody>
                                    <tr>
                                        <td style={{ width: "40%", verticalAlign: 'top' }}>
                                            <div style={{ fontSize: 'smaller', color: '#2c66a4' }}>Personas con discapacidad</div>
                                            <div style={{ position: 'relative', top: '-5px', left: '0', fontSize: 'medium', color: '#2c66a4', fontWeight: 'bold', margin: 0, padding: 0 }}>
                                                {strPersonasconDiscapacidad}
                                            </div>
                                        </td>
                                        <td style={{ width: "60%", verticalAlign: 'top' }}>
                                            <div style={{ fontSize: 'smaller', color: '#2c66a4' }}>Orientaciones sexuales e identidades de género diversas</div>
                                            <div style={{ position: 'relative', top: '-5px', left: '0', fontSize: 'medium', color: '#2c66a4', fontWeight: 'bold', margin: 0, padding: 0 }}>
                                                {strOrientacionesSexualesEIdentidadesDeGeneroDiversas}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ verticalAlign: 'top' }}>
                                            <div style={{ fontSize: 'smaller', color: '#2c66a4' }}>Personas en proceso de reincorporación</div>
                                            <div style={{ position: 'relative', top: '-5px', left: '0', fontSize: 'medium', color: '#2c66a4', fontWeight: 'bold', margin: 0, padding: 0 }}>
                                                {strPersonaEnProcesoDeReincorporacion}
                                            </div>
                                        </td>
                                        <td style={{ verticalAlign: 'top' }}>
                                            <div style={{ fontSize: 'smaller', color: '#2c66a4' }}>Personas defensoras<br />y líderes sociales</div>
                                            <div style={{ position: 'relative', top: '-5px', left: '0', fontSize: 'medium', color: '#2c66a4', fontWeight: 'bold', margin: 0, padding: 0 }}>
                                                {strPersonasDefensorasLideresSociales}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ verticalAlign: 'top' }}>
                                            <div style={{ fontSize: 'smaller', color: '#2c66a4' }}>Víctimas</div>
                                            <div style={{ position: 'relative', top: '-5px', left: '0', fontSize: 'medium', color: '#2c66a4', fontWeight: 'bold', margin: 0, padding: 0 }}>
                                                {strVictimas}
                                            </div>
                                        </td>
                                        <td style={{ verticalAlign: 'top' }}>
                                            <div style={{ fontSize: 'smaller', color: '#2c66a4' }}>Personas campesinas</div>
                                            <div style={{ position: 'relative', top: '-5px', left: '0', fontSize: 'medium', color: '#2c66a4', fontWeight: 'bold', margin: 0, padding: 0 }}>
                                                {strPersonasCampesinas}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default Vulnerables;